import { DATALAYER_PUSH_TIMEOUT } from 'settings';
import gtmSendEvent from './gtmSendEvent';

const gtmSendEventAsync = (event: any) => {
  return new Promise((resolve) => {
    if (!event) {
      resolve(null);
    }

    const timeOutId = setTimeout(resolve, DATALAYER_PUSH_TIMEOUT);

    gtmSendEvent({
      ...event,
      eventCallback: () => {
        clearTimeout(timeOutId);
        resolve(null);
      },
    });
  });
};

export default gtmSendEventAsync;
